import { useState, useEffect } from "react";
import useIdleTimeout from "../../components/common/UseIdle";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";

const InactiveModal = () => {
    const [openModal, setOpenModal] = useState(false)
    const [remaining, setRemaining] = useState(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setRemaining(Math.ceil(idleTimer.getRemainingTime() / 1000))
        }, 500)

        return () => {
            clearInterval(interval)
        }
    })

    const handleIdle = () => {
        setOpenModal(true)
    }
    const { idleTimer } = useIdleTimeout({
        onPrompt: handleIdle,
        idleTime: 60 * 3,
        setModal: (val: any) => setOpenModal(val)
    })

    const stay = () => {
        setOpenModal(false)
        idleTimer.reset()
    }

    const handleLogout = () => {
        setOpenModal(false)
        window.location.reload()
    }


    return <>
        <Modal backdrop="static" isOpen={openModal} centered>
            <ModalHeader>Inactivy detected</ModalHeader>
            <ModalBody>
                Your session will reset in {remaining} s. Are you around?
            </ModalBody>
            <ModalFooter>
                <Button
                    color="primary"
                    onClick={stay}
                >
                    <i className="fa fa-refresh" />
                    &nbsp;Yes
                </Button>
            </ModalFooter>
        </Modal>
    </>
}

export default InactiveModal